/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './ProductCard.scss';

import { isString } from 'lodash';
import React from 'react';
import { arrayOf, element, oneOfType, string, bool } from 'prop-types';

import { contentConverter } from 'services/Content';
import { transformMessageText } from 'state/IRT/IRTMessagesReducer';

const ProductCard = ({
  title = '',
  description = '',
  content = '',
  buttons,
  className = '',
  children,
  isMarketingTest,
  messageId = ''
}) => (
  <div data-testid="product-card" className={`product-card ${className}`}>
    <div data-testid="product-card-title" className="product-card-title">
      {isString(title) ? title.toUpperCase() : title}
    </div>
    <p
      data-testid="product-card-description"
      className="product-card-description">
      {description}
    </p>
    {isString(content) && isMarketingTest ? (
      <div
        className="product-card-content"
        data-testid="product-card-content"
        dangerouslySetInnerHTML={{
          __html: contentConverter.makeHtml(
            transformMessageText(content, messageId)
          )
        }}
      />
    ) : (
      <div data-testid="product-card-content" className="product-card-content">
        {content}
      </div>
    )}
    {children || (
      <div data-testid="product-card-links" className="product-card-links">
        {buttons}
      </div>
    )}
  </div>
);

ProductCard.propTypes = {
  title: oneOfType([string, element]),
  description: oneOfType([string, element]),
  content: oneOfType([string, element]),
  buttons: oneOfType([arrayOf(element), element]),
  isMarketingTest: bool,
  className: string,
  children: element
};

export default ProductCard;
